import React, { useState, useEffect, useRef } from 'react'

//redux
import { useDispatch, useSelector } from 'react-redux'
import WorkspacesAction from '../../redux/actions/workspaces/WorkspacesAction'
import { IRootState } from 'redux/reducers';

//helpers
import { BuildPath } from '../../helpers/Paths'

//components
import ModalWrapper from './ModalWrapper'
import ModalHeader from './ModalHeader'
import { BasicButton } from 'thrive-components';

import 'url-search-params-polyfill';
import '../../css/workspaceIntro.scss';



const IntroToWorkspaceModal = () => {  
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [showModal, setShowModal] = useState(false) 
    
    const dispatch = useDispatch()
    const profileImage = useSelector((state: IRootState)  => state.profile.profileImage)
    
    const queryStringCheck = () => {
        if (sessionStorage.getItem("showmodel") === "true"){ 
            sessionStorage.removeItem('showmodel')
            return setShowModal(true)
        }
        return setShowModal(false)
    }

    // Inital load
    useEffect(() => {
        queryStringCheck()
        dispatch(WorkspacesAction.requestWorkspaces())
    }, [])

    useEffect(() =>  {
        if (showModal) {
            document.documentElement.style.overflowY = "hidden"
        } else {
            document.documentElement.style.overflowY = "initial"
        }

        return () => {document.documentElement.style.overflowY = "initial"}
    }, [showModal])

    const playVideo = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    }
  
    return(
        <ModalWrapper className={"workspace-introduction-modal"} isOpen={showModal} escClose={true} onRequestClose={() =>  setShowModal(false)}>      
            <div className="workspace-intro">
                <ModalHeader 
                    title='Welcome to your Workspace 🛠' 
                    text='Find out how to add pages, lists, videos, images, weblinks and more by watching this quick 2 minute video.' 
                    imageURL={profileImage} 
                    cssClass='workspace-sub-header'
                />
                
                <div className="video-container">
                    <div className="thrive-recommends">
                        <img 
                            className='chevron' 
                            src={`${BuildPath()}/images/icons/star.svg`} 
                            alt=""
                        />
                        
                        Thrive recommends!
                    </div>

                    <video
                        ref={videoRef}
                        onPlay={() => playVideo()}
                        controls
                        width="100%"
                        aria-describedby="video-description"
                    >
                        <source src="/content/tracks/video/ThriveCMSDemo.mp4" type="video/mp4" />
                        
                        <track
                            src="/content/tracks/video/ThriveCMSDemo.en.vtt"
                            kind="captions"
                            srcLang="en"
                            label="English captions"
                            default
                        />
                        
                        Your browser does not support the video tag.
                    </video>              

                    <p className='step-by-step'>Step by step video on how to add content to your app</p>
                </div>

                <BasicButton 
                    className={"skip-step-button"}
                    content={"Skip this step"}
                    onButtonClick={() => setShowModal(false)} 
                    ariaLabel={'Skip this Step'}
                />
            </div>
        </ModalWrapper>
    )
}

export default IntroToWorkspaceModal